module.exports = __webpack_public_path__ + "img/SANS_UN_BRUIT_J1_30s.03f0e94f.jpg";